import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {
    GameDetailHistoryHeaderBarGameRoundDateComponent
} from "./parts/game-round-date/game-detail-history-header-bar-game-round-date.component";
import {
    GameHeaderBarCloseGameButtonComponent
} from "../common/parts/close-game-button/game-header-bar-close-game-button.component";
import {CyClass} from "../../../../../common/cy-classes";
import {
    GameDetailHistoryHeaderBarTopSectionBox
} from "./boxes/top-section/game-detail-history-header-bar-top-section.box";
import {GameDetailHistoryHeaderBarRootBox} from "./boxes/root/game-detail-history-header-bar-root.box";
import {
    GameDetailHistoryHeaderBarTopLeftSectionBox
} from "./boxes/top-section/left/game-detail-history-header-bar-top-left-section.box";
import {
    GameDetailHistoryHeaderBarTopRightSectionBox
} from "./boxes/top-section/right/game-detail-history-header-bar-top-right-section.box";
import {
    GameDetailHistoryHeaderBarGameTitleComponent
} from "./parts/game-title/game-detail-history-header-bar-game-title.component";
import {PipeHorizontalSeparatorBox} from "../../../../basic-components/pipe-separator/pipe-horizontal-separator.box";

interface GameDetailHistoryHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
    renderTopSection?: () => React.ReactElement;
    renderTopLeftSection?: () => React.ReactElement;
    renderTopRightSection?: () => React.ReactElement;
    renderBottomSection?: () => React.ReactElement;
}

export const GameDetailHistoryHeaderBarComponent = observer(
    class GameDetailHistoryHeaderBarComponent extends OrbitComponent<GameDetailHistoryHeaderBarComponentProps> {
        private _captureElementRef = (element: HTMLElement) => {
            if(element) {
                this.props.gameContext.gameParts.headerBarRenderer?.setGamePartElementRef(element);
            }
        }

        private _renderTopLeftSection = () => {
            if(this.props.renderTopLeftSection) {
                return this.props.renderTopLeftSection();
            }
            return (
                <GameDetailHistoryHeaderBarTopLeftSectionBox>
                    <GameDetailHistoryHeaderBarGameTitleComponent gameContext={this.props.gameContext}/>
                    <PipeHorizontalSeparatorBox/>
                    <GameDetailHistoryHeaderBarGameRoundDateComponent gameContext={this.props.gameContext}/>
                </GameDetailHistoryHeaderBarTopLeftSectionBox>
            );
        }

        private _renderTopRightSection = () => {
            if(this.props.renderTopRightSection) {
                return this.props.renderTopRightSection();
            }
            return (
                <GameDetailHistoryHeaderBarTopRightSectionBox>
                    <GameHeaderBarCloseGameButtonComponent/>
                </GameDetailHistoryHeaderBarTopRightSectionBox>
            )
        }


        private _renderTopSection = () => {
            if(this.props.renderTopSection) {
                return this.props.renderTopSection();
            }

            return (
                <GameDetailHistoryHeaderBarTopSectionBox>
                    {this._renderTopLeftSection()}
                    {this._renderTopRightSection()}
                </GameDetailHistoryHeaderBarTopSectionBox>
            );
        }

        private _renderBottomSection = () => {
            if(this.props.renderBottomSection) {
                return this.props.renderBottomSection();
            }
            return null;
        }

        render() {
            return (
                <GameDetailHistoryHeaderBarRootBox ref={this._captureElementRef} className={CyClass('cy-details-history-header')}>
                    {this._renderTopSection()}
                    {this._renderBottomSection()}
                </GameDetailHistoryHeaderBarRootBox>
            );
        }
    }
);
